import type { ServiceProvider as BaseServiceProvider } from '@takeshape/service-providers';
import type { ServiceProvider, ServiceProviderUI } from '../types';

export const serviceProviderUiDefaults: ServiceProviderUI = {
  experimental: false,
  requiresOAuthFlow: false,
  hasConnectionStatus: false,
  hasIntrospectableSchema: false,
  titleToId: true,
  titleToNamespace: false,
  defaultAuthenticationType: 'none',
  defaultEndpoint: '',
  avatarPath: '',
  logoPath: ''
};

export function createServiceProvider(base: BaseServiceProvider & Partial<ServiceProviderUI>): ServiceProvider {
  return {
    ...serviceProviderUiDefaults,
    hasIntrospectableSchema: Boolean(base.introspectionType),
    ...base
  };
}
